import {
  Box,
  Button,
  Modal,
  TextareaAutosize,
  TextField,
} from "@material-ui/core";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React from "react";
import { updateSavedQuery } from "../../../Apis/QueryApi";
import {
  SAVED_QUERY_MARKET_OPTIONS,
  UNDEFINED_MARKET_LABEL,
  UNDEFINED_MARKET_SELECT_VALUE,
  savedQueryMarketToSelectValue,
  selectValueToSavedQueryMarketPayload,
} from "../../../constants/savedQueryMarkets";

function clampRank1to5(v) {
  if (v == null || v === "") {
    return 1;
  }
  const n = typeof v === "number" ? v : parseInt(String(v).trim(), 10);
  if (Number.isNaN(n)) {
    return 1;
  }
  return Math.min(5, Math.max(1, n));
}

const EditQueryModal = ({
    fetchData,
    open,
    setOpen,
    currentEditQuery,
    setCurrentEditQuery,
}) => {
    const [loading, setLoading] = React.useState(false);

    const handleUpdate = async (event, queryId) => {
        event.preventDefault();
        setLoading(true);
        try {
            const queryStr = (currentEditQuery.content ?? "").trim();
            if (!queryStr) {
                return;
            }
            const sortOrder = clampRank1to5(
                currentEditQuery.sort_order != null
                    ? currentEditQuery.sort_order
                    : 1
            );
            const data = {
                query: queryStr,
                description: currentEditQuery.description ?? "",
                sort_order: sortOrder,
                market: selectValueToSavedQueryMarketPayload(
                    currentEditQuery.market
                ),
            };
            const res = await updateSavedQuery(data, queryId);
            if (res) {
                setOpen(false);
                fetchData();
            }
        } finally {
            setLoading(false);
        }
    };


    const handleEditClose = () => {
        setCurrentEditQuery({});
        setOpen(false);
    };

    const displayRank = clampRank1to5(
        currentEditQuery.sort_order != null
            ? currentEditQuery.sort_order
            : 1
    );
    const marketValue = savedQueryMarketToSelectValue(
        currentEditQuery.market
    );

    return (
        <Modal
            open={open}
            onClose={()=>handleEditClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                maxWidth: "800px",
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
                }}
            >
                <h3 className="fs-3">Edit SDQL Form</h3>
                <form onSubmit={(e) => handleUpdate(e, currentEditQuery.id)}>
                <TextField
                    style={{ width: "100%", marginBottom: "20px" }}
                    type="text"
                    name="query"
                    label="SDQL"
                    variant="standard"
                    value={currentEditQuery.content}
                    onChange={(e) =>
                        setCurrentEditQuery({
                            ...currentEditQuery,
                            content: e.target.value,
                        })
                    }
                    required
                />

                <TextareaAutosize
                    aria-label="Description"
                    minRows={3}
                    placeholder="Description"
                    name="description"
                    value={currentEditQuery.description}
                    onChange={(e) =>
                    setCurrentEditQuery({
                        ...currentEditQuery,
                        description: e.target.value,
                    })
                    }
                    style={{
                    width: "100%",
                    marginBottom: "20px",
                    borderRadius: "10px",
                    borderColor: "rgba(0, 0, 0, 0.42)",
                    padding: "10px",
                    }}
                />

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 2,
                        marginBottom: "6px",
                    }}
                >
                <TextField
                    type="number"
                    name="sort_order"
                    label="Rank 1 to 5"
                    variant="standard"
                    value={displayRank}
                    onChange={(e) => {
                        const v = e.target.value;
                        if (v === "") {
                            setCurrentEditQuery({
                                ...currentEditQuery,
                                sort_order: 1,
                            });
                            return;
                        }
                        const n = parseInt(v, 10);
                        setCurrentEditQuery({
                            ...currentEditQuery,
                            sort_order: clampRank1to5(
                                Number.isNaN(n) ? 1 : n
                            ),
                        });
                    }}
                    inputProps={{ min: 1, max: 5, step: 1 }}
                    style={{ width: "200px" }}
                />
                <FormControl variant="standard" sx={{ minWidth: 160 }}>
                    <InputLabel id="edit-modal-market-label">Market</InputLabel>
                    <Select
                        labelId="edit-modal-market-label"
                        label="Market"
                        name="market"
                        value={marketValue}
                        onChange={(e) => {
                            const v = e.target.value;
                            setCurrentEditQuery({
                                ...currentEditQuery,
                                market:
                                    v === UNDEFINED_MARKET_SELECT_VALUE
                                        ? null
                                        : v,
                            });
                        }}
                    >
                        <MenuItem value={UNDEFINED_MARKET_SELECT_VALUE}>
                            {UNDEFINED_MARKET_LABEL}
                        </MenuItem>
                        {SAVED_QUERY_MARKET_OPTIONS.map((m) => (
                            <MenuItem key={m} value={m}>
                                {m}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                </Box>
                <Box
                    role="img"
                    aria-label={`Rank ${displayRank} of 5`}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                        marginBottom: "20px",
                        lineHeight: 1,
                    }}
                >
                    {[1, 2, 3, 4, 5].map((i) => (
                        <span
                            key={i}
                            style={{
                                fontSize: "0.95rem",
                                opacity: i <= displayRank ? 1 : 0.2,
                                filter: i <= displayRank ? "none" : "grayscale(0.5)",
                            }}
                        >
                            🦴
                        </span>
                    ))}
                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={loading}
                >
                    Update
                </Button>
                </form>
            </Box>
        </Modal>
    );
};

export default EditQueryModal;
